import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import VueToasted from "vue-toasted";
import axios from "./axiosClient";

Vue.config.productionTip = false;

Vue.prototype.$http = axios;

Vue.use(VueToasted, {
  iconPack: "material",
  duration: 3000,
  icon: "error_outline",
  position: "top-center"

  // set your iconPack, defaults to material. material|fontawesome|custom-class
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
